<template>
  <div class="row">
    <ul class="nav_bar">
      <router-link tag="li" to="/Home">首页</router-link>
      <!-- <router-link tag="li" to="/queryOnline">在线查询</router-link> -->
      <!-- <router-link tag="li" to="/transNews">交通新闻</router-link>
      <router-link tag="li" to="/eventMsg">交通事件</router-link> -->
      <router-link tag="li" to="/bus">公交出行</router-link>
      <li>
        <a href="https://www.12306.cn/index/" target="_blank">铁路出行</a>
      </li>
      <li>
        <a href="https://flights.ctrip.com/actualtime/search" target="_blank">民航出行</a>
      </li>
      <li>
        <a href="https://www.bus365.com/city/150600000000.html" target="_blank">大巴出行</a>
      </li>
      <router-link tag="li" to="/hyjdMsg">行业监督信息</router-link>
      <!-- <router-link tag="li" to="/tszxSevers/complaintsReport">投诉咨询服务</router-link> -->
      <router-link tag="li" to="/jtzjQuery/credentialsquery1">交通证件查询</router-link>
      <router-link tag="li" to="/bmQuery">便民查询</router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {};
  }
};
</script>

<style scoped>
.row {
  margin-bottom: 5px;
}
.nav_bar {
  height: 40px;
  width: 100%;
  line-height: 40px;
  background: rgba(1, 152, 251, 1);
  color: white;
  font-size: 15px;
  font-weight: 400;
  /* </span>border: 1px solid red; */
}
.nav_bar li {
  float: left;
  /* width: 120px; */
  padding: 0 20px;
  text-align: center;
}
.nav_bar li a {
  color: white;
}
.nav_bar li:hover {
  cursor: pointer;
  background-color: rgba(6, 93, 183, 1);
}
.tab-item-active {
  background-color: rgba(6, 93, 183, 1);
}
a {
  /* border: 1px solid red; */
  display: block;
  /* width: 100%; */
}
.router-link-active {
  background-color: rgba(6, 93, 183, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue